<template>
    <div class="common-tab-root">
        <!-- 搜索和城市选择区域  -->
        <div class="search">
            <div style="margin-right: 10px;">
                <div class="custom-dropdown">
                    <div class="dropdown-title" @click="toggleDropdown()">
                        <i class="el-icon-location-outline "></i>
                        <span>{{ currentcity }}</span>
                    </div>
                    <div v-show="activeDropdown === 0" class="dropdown-content">
                         <div v-for="(subItem, subIndex) in cityList" 
                            :key="subIndex" 
                            v-if="subItem.status"
                            class="dropdown-item"
                            @click="cityClick(subItem, 0, subIndex)">
                            {{ subItem.title }}
                        </div>
                        <div v-for="(subItem, subIndex) in cityList" 
                            :key="subIndex" 
                            v-if="!subItem.status"
                            class="dropdown-items"
                            >
                            {{ subItem.title }}
                        </div>
                    </div>
                </div>
            </div>
            <el-input placeholder="搜索设备或品牌" v-model="keyword" @keyup.enter.native="serach"></el-input>
            <div class="btn" @click="serach">搜索</div>
        </div>

        <!-- 筛选内容区域 -->
        <div class="content">
            <!-- 设备筛选 -->
            <div class="filter-category">
                <div class="header">
                    <span class="label">设备 |</span>
                    <!-- 展开/收起按钮 -->
                    <el-button
                        type="text"
                        class="expand-toggle"
                        v-if="equipmentList.length > ROW_ITEM_LIMIT"
                        @click="toggleExpansion('equipment')"
                    >
                        {{ expansionState.equipment ? '收起' : '更多' }}
                        <i :class="expansionState.equipment ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </el-button>
                </div>
                <div class="tag-list-wrapper" :class="{ 'expanded': expansionState.equipment }">
                    <div class="tag-list">
                        <el-tag 
                            @click="SelectEquipment(item.id)" 
                            v-for="item in equipmentList" 
                            :key="item.id" 
                            size="medium"
                            :effect="equipment_id === item.id ? 'dark' : 'plain'">
                            {{ item.title }}
                        </el-tag>
                    </div>
                </div>
            </div>

            <!-- 品牌筛选 -->
            <div class="filter-category">
                <div class="header">
                    <span class="label">品牌 |</span>
                     <!-- 展开/收起按钮 -->
                     <el-button 
                        type="text"
                        class="expand-toggle"
                        v-if="supplierBrand.length > ROW_ITEM_LIMIT"
                        @click="toggleExpansion('brand')"
                    >
                        {{ expansionState.brand ? '收起' : '更多' }}
                        <i :class="expansionState.brand ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    </el-button>
                </div>
                <div class="tag-list-wrapper" :class="{ 'expanded': expansionState.brand }">
                    <div class="tag-list">
                        <el-tag 
                            @click="SelectBrand(item.id)" 
                            v-for="item in supplierBrand" 
                            :key="item.id" 
                            size="medium"
                            :effect="brand_id === item.id ? 'dark' : 'plain'">
                            {{ item.title }}
                        </el-tag>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        equipmentList: { type: Array, default: () => ([]) },
        equipment_id: { type: Number, default: 0 },
        supplierBrand: { type: Array, default: () => ([]) },
        brand_id: { type: Number, default: 0 },
        cityList:{ type: Array, default: () => [] },
    },
    name: 'CommonTab',
    data() {
        return {
            keyword: '',
            currentcity:'广州',
            activeDropdown: null,
            // 为每个类别维护独立的展开状态
            expansionState: {
                equipment: false, // 设备筛选区是否展开
                brand: false,     // 品牌筛选区是否展开
            },
            // 定义一个阈值，超过这个数量的标签才显示“下拉”按钮
            ROW_ITEM_LIMIT: 21, 
        }
    },
    computed: {
        ...mapState({
            selectedMenuItem: state => state.selectedMenuItem
        })
    },
    methods: {
        // 展开/收起切换方法
        toggleExpansion(category) {
            if (this.expansionState.hasOwnProperty(category)) {
                this.expansionState[category] = !this.expansionState[category];
            }
        },

        SelectEquipment(e) {
            this.$emit('selectEquipment', e); 
        },
        SelectBrand(e) {            
            this.$emit('selectBrand', e);
        },
        toggleDropdown() {
             // 假设城市下拉的index为0
            this.activeDropdown = this.activeDropdown === 0 ? null : 0;
        },
        cityClick(item) {
            this.currentcity = item.title;
            this.activeDropdown = null;
            this.$emit('selectCity', item.city_id);
        },
        inputChange(){
            this.$emit('inputChange', this.keyword);
        },
        serach(){
            this.$emit('serach', this.keyword);
        }
    }
}
</script>

<style lang="less" scoped>
.search {
    display: flex;
    margin-bottom: 20px;
    align-items: center;
    .el-input {
        width: 28em;
        font-size: 0.7em;
       
    }

    .btn {
        font-size: 0.7em;
        margin-left: 10px;
        background-color: #FF6600;
        color: #fff;
        border-radius: 5px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 3.5em;
        cursor: pointer;
    }
    .custom-dropdown {
        flex: 1;
        position: relative;
        text-align: center;
        
        .dropdown-title {
            padding: 12px 0;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #666;
            i {
                margin: 0 5px;
            }
        }
        
        .dropdown-content {
            min-width: 100%; 
            position: absolute;
            top: 100%;
            left: 0;
            background-color: #fff;
            border: 1px solid #eee;
            border-radius: 4px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            z-index: 100;
            max-height: 300px;
            overflow-y: auto;
            color: #666;
        }
 
        /* 将公共样式提取出来，并添加关键属性 */
        .dropdown-content .dropdown-item,
        .dropdown-content .dropdown-items {
            padding: 10px;
            cursor: pointer;
            white-space: nowrap; 
        }
        
        .dropdown-content .dropdown-item:hover {
            background-color: #f5f5f5;
            color: #FF6600;
        }
        
        .dropdown-content .dropdown-items {
            background-color: #f7f7f7;
            color: #999;
        }
    }
}



.content {
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 10px;
    padding: 10px 20px 20px; // 调整了内边距
}

.filter-category {
    // 每个筛选类别（设备、品牌）的容器
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 0;
    }

    .header {
        display: flex;
        justify-content: space-between; // 让label和按钮两端对齐
        align-items: center;
        margin-bottom: 15px; // 标题和标签列表的间距
    }

    .label {
        font-size: 1em;
        font-weight: 600;
        color: #666;
    }

    .expand-toggle {
        // "下拉/收起" 按钮的样式
        padding: 0; // 移除 Element UI 按钮的默认内边距
        color: #909399;
        font-weight: normal;
        &:hover {
            color: #409EFF;
        }
    }
}

.tag-list-wrapper {
    max-height: 78px; // 默认最大高度，大约是2行标签的高度。
    overflow: hidden;
    transition: max-height 0.4s ease-in-out;

    // 当容器有 .expanded 类时，展开
    &.expanded {
        max-height: 2000px; // 一个足够大的值，确保所有标签都能显示
    }
}

.tag-list {
    display: flex;
    flex-wrap: wrap;

    .el-tag {
        margin-right: 15px;
        margin-bottom: 12px; // 统一用 margin-bottom 控制行间距
        cursor: pointer;
        font-size: 0.9em;
        height: 30px;
        line-height: 30px;
        padding: 0px 15px;
        border: 1px solid #eee;
        border-radius: 10px;
        transition: 0.3s;
        color: #666;
        
        &--dark {
            background-color: #FF6600;
            color: #fff;
            border-color: #FF6600;
        }
    }
}
</style>
